import { Instagram, Youtube, Twitter, Music2, Twitch, Github, Figma, Dribbble } from "lucide-react";
import { Reveal } from "./Reveal";

const ROW = [
  { icon: Music2, label: "Spotify" },
  { icon: Youtube, label: "YouTube" },
  { icon: Instagram, label: "Instagram" },
  { icon: Twitter, label: "X" },
  { icon: Twitch, label: "Twitch" },
  { icon: Github, label: "GitHub" },
  { icon: Figma, label: "Figma" },
  { icon: Dribbble, label: "Dribbble" },
];

export const Integrations = () => (
  <section id="integrations" data-testid="integrations" className="px-6 py-28 md:px-12 lg:px-24">
    <div className="mx-auto max-w-6xl">
      <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-2">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-inkMuted">Integrations</p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tighter text-ink md:text-5xl lg:text-6xl">
            Plugs into the tools you already love
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="max-w-md text-sm leading-relaxed text-inkMuted md:text-base lg:text-right">
            Embed live content from 40+ platforms. Your feeds, drops and streams stay
            in sync — automatically.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-2 gap-5 sm:grid-cols-4">
        {ROW.map((item, i) => (
          <Reveal key={item.label} delay={(i % 4) * 0.06}>
            <div className="group flex h-28 flex-col items-center justify-center gap-3 rounded-2xl border border-line bg-surface shadow-soft transition-transform duration-300 hover:-translate-y-1">
              <item.icon size={26} className="text-ink transition-colors group-hover:text-lime" />
              <span className="text-xs font-medium text-inkMuted">{item.label}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
